import Vue from 'vue';
import axios from 'axios';
import { Autocomplete } from './modules/autocomplete';
import * as ExpenseSplitter from './modules/expenseSplitter';
import * as CategoryAnalysis from './modules/categoryAnalysis';

window.Vue = Vue;
window.axios = axios;
window.Autocomplete = Autocomplete;
window.BudgetPlanner = {
    Autocomplete,
    ExpenseSplitter,
    CategoryAnalysis
};

export { Autocomplete, ExpenseSplitter, CategoryAnalysis };
